import React,{ Fragment } from "react";
import PropTypes from "prop-types";
import ReactTable from 'react-table'
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { get,patch,put } from '../../../server/actions';
import {_addNotification, _addNotificationError} from '../../../server/util'
import moment from 'moment'
import { date_format } from "../../../server/constants";
class EventsList extends React.Component{
    constructor(props){
        super(props);
        this.state={
            loading:false,
            events:[],
            searchText:'',
            filterEvents:[]
        }
        this.bindEvents=this.bindEvents.bind(this);
    }
    componentWillMount=()=>{
        this.bindEvents();
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }
    bindEvents=()=>{
        this.setState({loading: true});
        get('/eventInfoes/search/findByMealSchoolSchoolIdAndSchoolYear?mealSchoolId='+ sessionStorage.getItem("SchoolId")+'&schoolYear='+sessionStorage.getItem('schoolYearValue')+'&access_token=')
        .then((response)=>{
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then((data)=>{
            this.setState({events:data._embedded.eventInfoes||[],loading: false},()=>{
                this.setState({filterEvents:this.filterData(this.state.searchText)||[], loading:false})
            })
        }).catch((error) => {
            this.setState({loading: false});
            console.log('Get events data response', error)
        })
    }
    searchTextChange=(e)=>{
        this.setState({searchText:e.target.value,filterEvents:this.filterData(e.target.value)})
    }
    filterData=(search)=>{
       return this.state.events.filter(item=>{
           return (item.isActive===true)&&(item.eventName||'').toUpperCase().includes(search.toUpperCase())
       });
    }
    publish_unpublish=(id)=>{
        this.setState({loading: true});
        let headers = {
            'Content-Type': 'application/json'
        };        
        put('/publishEvent/'+id+'?access_token=',undefined).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
            }).then(data => {
                _addNotification("Event published successfully.", this);
                this.setState({loading: false},
                    ()=>{
                        this.bindEvents()
                    });                    
            }).catch(
                (error) => {
                    console.log('Event data not saved', error);
                    this.setState({loading: false});
                }
            );
        }
        active_inactiveEvent=(id,activeStatus)=>{
            this.setState({loading: true});
            let headers = {
                'Content-Type': 'application/json'
            };
            let reqBody={
                isActive:activeStatus
            }
            patch('/eventInfoes/'+id+'?access_token=',JSON.stringify(reqBody)).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
                }).then(data => {
                    _addNotification(activeStatus?"Event activated successfully.":"Event inactivated successfully.", this);
                    this.setState({loading: false},
                        ()=>{
                            this.bindEvents()
                        });                    
                }).catch(
                    (error) => {
                        console.log('Event data not saved', error);
                        this.setState({loading: false});
                    }
                );
            }
    getColumns=()=>{
        let columns = [];
        columns.push({
            accessor: 'eventName',
            id:'Event',
            Header: 'EVENT',
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true
        });
        columns.push({
            accessor: 'startDate',
            id:'startDate',
            Header: 'START DATE',
            style: {textAlign: 'center'},
            width:120,
            Cell: ({row}) => (
                <span style={{textAlign:'center'}}>
                    {moment(new Date(row._original.startDate)).format(date_format())} </span>),
            sortable:true,
            defaultSortDesc:true
        });
        columns.push({
            accessor: 'endDate',
            id:'endDate',
            Header: 'END DATE',
            width:120,
            style: {textAlign: 'center'},
            Cell: ({row}) => (
                <span style={{textAlign:'center'}}>
                    {moment(new Date(row._original.endDate)).format(date_format())} </span>),
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true
        });
        columns.push({
            id:'publish',
            Header: 'PUBLISH',
            width:80,
            Cell: ({row}) => (
                    !row._original.isPublished?
                    <a title="Publish Event" onClick={() =>{
                        let id=row._original._links.self.href.split('/').pop();
                        this.publish_unpublish(id);
                    }}><i className="fa fa-cloud-upload color-2 fa-icon" style={{fontSize:'30px'}}></i></a>:
                     <i className="fa fa-cloud-upload" style={{color:'gray',fontSize:'30px'}}></i>
                    ),
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true

        });
        columns.push({
            id:'action',
            Header: 'Action',
            width:80,
            style: {textAlign: 'center'},
            Cell: ({ row }) => (<div>
                <a title="Edit Record" onClick={() =>{
                    let id=row._original._links.self.href.split('/').pop();
                    this.context.router.history.push('/schoolAdmin/eventRecord/'+id)
                }}><i
                    className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon" /></a>               
                <a title="Delete Record" onClick={() =>{
                    let id=row._original._links.self.href.split('/').pop();
                    this.active_inactiveEvent(id,!row._original.isActive)
                }}><i
                    className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" /></a>
            </div>)
        });
        return columns
    }
    render(){
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },

        };
        return(<Fragment>
         <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="sectionTitle col-md-12">
                            <h2>
                                <span>Events</span>
                                <div id="selector"
                                    className="btn-group pull-right"
                                    style={{ margin: '5px' }}>
                                    
                                    </div>
                            </h2>                            
                        </div>
                            <div className="col-xs-3 pull-left">
                                <input type="text" id="search"
                                    className="form-control"
                                    style={{
                                        float: 'left',
                                        margin: '5px 0'
                                    }}
                                    name="search"
                                    placeholder="Search.."
                                    onChange={this.searchTextChange} />
                            </div>
                            <div className="col-xs-9 pull-right">
                                <button type="button"
                                        className="btn btn-xs btn-success pull-right"
                                        id="addEvents"
                                        style={{
                                            margin: 0,
                                            marginLeft: 3,
                                            fontSize: 12
                                        }}
                                        onClick={(e) => {
                                            this.context.router.history.push('/schoolAdmin/eventRecord/'+0)
                                        }}
                                    ><i className="fa fa-plus" aria-hidden="true"></i> Add Events
                                </button>
                            </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="table-responsive">
                                <ReactTable
                                    data={this.state.filterEvents}
                                    columns={this.getColumns()}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                    noDataText='No data found'
                                    sortable={true}
                                    defaultSorting={[{
                                        id: 'eventName',
                                        desc: false
                                        }]}                                                            
                                    {...checkboxProps}
                                />
                            </div>
                        </div>
                    </div>
                </section>
        </Fragment>)
    }
}
EventsList.contextTypes = {
    router: PropTypes.object.isRequired
}
export default EventsList


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageEvents/EventsList.jsx